export default "__VITE_ASSET__C6Rd$pfo__"